"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3952],{

/***/ 63952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionNewsletterV2": function() { return /* binding */ SectionNewsletterV2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);



const Wrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    padding: "calc($headerHeight + $96) $20",
    marginBottom: "$mobileSectionMarginL",
    marginTop: 0,
    "@lg": {
        marginTop: 0,
        marginBottom: "$desktopSectionMarginL"
    },
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    backgroundColor: "$black",
    color: "$white",
    "@md": {
        padding: "264px $32"
    }
});
const Heading = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h2", {
    projectFont: "heading02",
    marginBottom: "$64",
    maxWidth: "724px",
    textAlign: "center"
});
const NewsletterWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gap: "$8",
    justifySelf: "center",
    width: "100%",
    "@md": {
        width: "50vw"
    },
    "@lg": {
        width: "30vw"
    }
});
const NewsletterForm = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    margin: 0
});
const NewsletterPrivacyPolicyInfo = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    projectFont: "ui04",
    textAlign: "center",
    color: "$white_06",
    a: {
        textDecoration: "underline",
        textUnderlineOffset: "2px"
    }
});
const SectionNewsletterV2 = (param)=>{
    let { title , anchorId , privacyPolicyInfo , klaviyoFormId  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrap, {
        ...anchorId && {
            id: anchorId
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(NewsletterWrap, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewsletterForm, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .KlaviyoForm */ .DM, {
                            formId: klaviyoFormId
                        })
                    }),
                    privacyPolicyInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewsletterPrivacyPolicyInfo, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .PortableText */ .YI, {
                            value: privacyPolicyInfo,
                            appearance: "plain"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);